import React, { useEffect } from 'react'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styled'
import Tabs from '../../../../../../Components/Tabs'
import { faFlask, faSeedling } from '@fortawesome/free-solid-svg-icons'
import { FormDados } from './dados'
import { Render } from '../../../../../../Components/CustomUi/render'
import { Composicao } from './composicao'

interface PropsForm {
  update: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacao_id: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricante_id: React.Dispatch<React.SetStateAction<number>>
  tecnologia: string
  setTecnologia: React.Dispatch<React.SetStateAction<string>>
  setTecnologia_id: React.Dispatch<React.SetStateAction<number>>
  volume_dose: string
  mascaraDecimal: Function
  dose_padrao: string
  setDose_padrao: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  origem_selecionada: string
  setOrigem_selecionada: React.Dispatch<React.SetStateAction<string>>
  setOrigem_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  tipo_biologico_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_biologico_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  tipo_aplicacao_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_aplicacao_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  microrganismo_selecionado: string
  setMicrorganismo_selecionado: React.Dispatch<React.SetStateAction<string>>
  setMicrorganismo_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  valor: string
  setValor: React.Dispatch<React.SetStateAction<string>>
  expoente: string
  setExpoente: React.Dispatch<React.SetStateAction<string>>
  porcentagem: string
  setPorcentagem: React.Dispatch<React.SetStateAction<string>>
  tipo_porcentagem: string
  setTipo_porcentagem: React.Dispatch<React.SetStateAction<string>>
  setTipo_porcentagem_id: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  cepa: string
  setCepa: React.Dispatch<React.SetStateAction<string>>
   densidade: string
    setDensidade: React.Dispatch<React.SetStateAction<string>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  editar_concentracao: number
  fake_loading: boolean
  data_biológicos: any[]
  data_formulação: any[]
  data_aplicação: any[]
  data_tecnologia: any[]
  data_microrganismos: any[]
  data_fabricante: any[]
  composicao_adicionada: any[]
  adicionarComposicao: Function
  editarComposicao: Function
  salvarComposicao: Function
  mudarConcentracao: Function
  remover_microrganismos: Function
  loadingComposicao: boolean
}

export const FormularioInoculantes: React.FC<PropsForm> = ({
  update,
  nome,
  setNome,
  volume_dose,
  mascaraDecimal,
  dose_padrao,
  setDose_padrao,
  formulacao,
  setFormulacao,
  setFormulacao_id,
  fabricante,
  setFabricante,
  setFabricante_id,
  tecnologia,
  setTecnologia,
  setTecnologia_id,
  observacao,
  setObservacao,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  origem_selecionada,
  setOrigem_selecionada,
  setOrigem_selecionada_id,
  tipo_biologico_selecionadas,
  setTipo_biologico_selecionadas,
  tipo_aplicacao_selecionadas,
  setTipo_aplicacao_selecionadas,
  microrganismo_selecionado,
  setMicrorganismo_selecionado,
  setMicrorganismo_selecionado_id,
  concentracao,
  setConcentracao,
  valor,
  setValor,
  expoente,
  setExpoente,
  porcentagem,
  setPorcentagem,
  tipo_porcentagem,
  setTipo_porcentagem,
  setTipo_porcentagem_id,
  cepa,
  setCepa,
  densidade,
  setDensidade,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  fake_loading,
  setNome_item_atual,
  editar_concentracao,
  data_aplicação,
  data_biológicos,
  data_formulação,
  data_tecnologia,
  data_microrganismos,
  data_fabricante,
  composicao_adicionada,
  adicionarComposicao,
  editarComposicao,
  salvarComposicao,
  mudarConcentracao,
  remover_microrganismos,
  loadingComposicao,
}) => {
  useEffect(() => {
    if (['Sólido', 'Turfosa', 'Liofilizada'].includes(formulacao)) {
      setTipo_porcentagem('m/m')
      setTipo_porcentagem_id(1)
    } else {
      setTipo_porcentagem('')
      setTipo_porcentagem_id(null)
    }
  }, [formulacao])

  return (
    <div>
      <HeaderDrawer>
        <div>{update > 0 ? 'Atualizar inoculante' : 'Cadastrar inoculante'}</div>
      </HeaderDrawer>
      <BodyDrawer>
        <Tabs
          tabs={[
            { descricao: 'Dados do inoculante', icone: faSeedling },
            {
              descricao: 'Composição',
              icone: faFlask,
              disabled: tipo_biologico_selecionadas.some(
                (item) => item.descr === 'Complexo de Microrganismos'
              ),
            },
          ]}
          selecionado={tab_selecionar_atual}
          trackWidth={404}
          onChange={setTab_selecionar_atual}
        />
        <Render condition={tab_selecionar_atual === 'Dados do inoculante'}>
          <FormDados
            nome={nome}
            setNome={setNome}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            setFormulacao_id={setFormulacao_id}
            fabricante={fabricante}
            setFabricante={setFabricante}
            setFabricante_id={setFabricante_id}
            tecnologia={tecnologia}
            setTecnologia={setTecnologia}
            setTecnologia_id={setTecnologia_id}
            volume_dose={volume_dose}
            mascaraDecimal={mascaraDecimal}
            observacao={observacao}
            setObservacao={setObservacao}
            origem_selecionada={origem_selecionada}
            setOrigem_selecionada={setOrigem_selecionada}
            setOrigem_selecionada_id={setOrigem_selecionada_id}
            tipo_biologico_selecionadas={tipo_biologico_selecionadas}
            setTipo_biologico_selecionadas={setTipo_biologico_selecionadas}
            tipo_aplicacao_selecionadas={tipo_aplicacao_selecionadas}
            setTipo_aplicacao_selecionadas={setTipo_aplicacao_selecionadas}
            dose_padrao={dose_padrao}
            setDose_padrao={setDose_padrao}
            data_biológicos={data_biológicos}
            data_formulação={data_formulação}
            data_aplicação={data_aplicação}
            data_tecnologia={data_tecnologia}
            data_fabricante={data_fabricante}
          />
        </Render>
        <Render condition={tab_selecionar_atual === 'Composição'}>
          <Composicao
            microrganismo_selecionado={microrganismo_selecionado}
            setMicrorganismo_selecionado={setMicrorganismo_selecionado}
            setMicrorganismo_selecionado_id={setMicrorganismo_selecionado_id}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            valor={valor}
            setValor={setValor}
            expoente={expoente}
            setExpoente={setExpoente}
            cepa={cepa}
            setCepa={setCepa}
            data_microrganismos={data_microrganismos}
            composicao_adicionada={composicao_adicionada}
            adicionarComposicao={adicionarComposicao}
            editarComposicao={editarComposicao}
            salvarComposicao={salvarComposicao}
            mudarConcentracao={mudarConcentracao}
            confirmar_exclusao={confirmar_exclusao}
            setConfirmar_exclusao={setConfirmar_exclusao}
            id_item_atual={id_item_atual}
            setId_item_atual={setId_item_atual}
            setNome_item_atual={setNome_item_atual}
            fake_loading={fake_loading}
            remover_microrganismos={remover_microrganismos}
            porcentagem={porcentagem}
            setPorcentagem={setPorcentagem}
            tipo_porcentagem={tipo_porcentagem}
            setTipo_porcentagem={setTipo_porcentagem}
            setTipo_porcentagem_id={setTipo_porcentagem_id}
            editar_concentracao={editar_concentracao}
            loadingComposicao={loadingComposicao}
            formulacao={formulacao}
            densidade={densidade}
            setDensidade={setDensidade}
          />
        </Render>
      </BodyDrawer>
    </div>
  )
}
